import React from "react";
import {
  Menu,
  MenuItem,
  Checkbox,
  ListItemText,
  Button,
  IconButton,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

export const getOptionLabel = (option) => {
  if (typeof option === "string") return option;
  if (typeof option === "number") return String(option);
  if (!option) return "";
  if (typeof option === "object") {
    if (typeof option.label === "string") return option.label;
    if (typeof option.name === "string") return option.name;
    if (React.isValidElement(option)) {
      const extractText = (node) => {
        if (typeof node === "string" || typeof node === "number") return String(node);
        if (Array.isArray(node)) return node.map(extractText).join("");
        if (React.isValidElement(node)) return extractText(node.props?.children);
        return "";
      };
      return extractText(option);
    }
  }
  return String(option);
};

const CheckboxDropdown = ({
  anchorEl,
  setAnchorEl,
  options,
  selectedOptions,
  onToggle,
  icon,
  label,
  useCustomIcons = false,
}) => {
  const open = Boolean(anchorEl);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button
        variant="outlined"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        startIcon={icon}
        sx={{
          height: "34px",
          borderRadius: "100px",
          border: "1px solid #837F39",
          backgroundColor: "#FEFEFE",
          color: "#0E0E0E",
          fontFamily: "Work Sans",
          fontWeight: 600,
          fontSize: "12px",
          textTransform: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          whiteSpace: "nowrap",
          px: "16px",
          gap: "8px",
        }}
      >
        {label}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            mt: 1,
            px: 1,
          },
        }}
      >
        {options?.map((option, idx) => {
          const labelText = getOptionLabel(option);
          const isChecked = (selectedOptions || []).some(
            (sel) =>
              sel === option ||
              (getOptionLabel(sel) && getOptionLabel(sel) === labelText)
          );

          return (
            <MenuItem key={idx} onClick={() => onToggle(option)}>
              <Checkbox
                checked={isChecked}
                icon={useCustomIcons ? <RadioButtonUncheckedIcon /> : undefined}
                checkedIcon={useCustomIcons ? <CheckCircleIcon /> : undefined}
                sx={{
                  color: "#837F39",
                  "&.Mui-checked": {
                    color: "#837F39",
                  },
                }}
              />
              <ListItemText
                primary={labelText}
                primaryTypographyProps={{
                  sx: {
                    fontFamily: "Work Sans",
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#0E0E0E",
                    textAlign: "left",
                  },
                }}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default CheckboxDropdown;
